import { useLocation, useNavigate } from "react-router-dom";
import ChatStore from "../../../store/chatStore";
import UIStore from "../../../store/uiStore";
import { FileStore } from "../../../store/fileUploadStore";
import { v4 as uuidv4 } from "uuid";
import { ArrowUp, SparkDarkSvg, SparkSvg } from "../../../assets";
import AddButton from "../../Button/AddButton";
import PromptStore from "../../../store/promptStore";
import { motion } from "framer-motion";
import ROUTES from "../../../router/routes";
import logger from "../../../services/Logger";
import { useTheme } from "../../../context/ThemeProvider";

export const NewChatButton = ({ theme }) => {
  const { colorScheme } = useTheme();
  const addChatDisabled = ChatStore((state) => state.addChatDisabled);
  const setTempChatId = ChatStore((state) => state.setTempChatId);
  const setPrompt = PromptStore((state) => state.setPrompt);
  const setShowSidebar = UIStore((state) => state.setShowSidebar);
  const navigate = useNavigate();
  const setFiles = FileStore((state) => state.setFiles);
  const setNewFiles = FileStore((state) => state.setNewFiles);
  const pathname = useLocation().pathname;

  const handleAddChat = async () => {
    if (pathname.startsWith("/spectra")) {
      navigate(`/chat`);
      return;
    }
    if (addChatDisabled) return;

    // Immediately disable the button to prevent rapid clicks
    ChatStore.getState().setAddChatDisabled(true);

    try {
      const chat_id = uuidv4();
      setTempChatId(chat_id);
      setFiles([]);
      setNewFiles([]);
      FileStore.getState().setFileLoading(false);
      setPrompt("");
      navigate(`/chat/${chat_id}`);

      // Re-enable the button after a short delay as a failsafe
      setTimeout(() => {
        ChatStore.getState().setAddChatDisabled(false);
      }, 1000);
    } catch (error) {
      logger.error('NewChatButton', 'Error in handleAddChat', { error: error.message });
      ChatStore.getState().setAddChatDisabled(false);
    }
  };

  const handleNewSpark = () => {
    navigate(ROUTES.SPARKS_DASH);
    // Close sidebar on mobile/tablet after navigation
    if (window.innerWidth < 940) {
      setShowSidebar(false);
    }
  };
  return (
     <motion.div
      className="flex items-center justify-between py-[10px] px-[12px]"
      initial="hover"
      whileHover="hover"
      animate="rest"
    >
      <motion.button
        type="button"
        aria-current={pathname.startsWith('/chat') || pathname.startsWith('/spark') ? 'page' : undefined}
        className="photon-navigation-link flex items-center justify-between gap-[7px] cursor-pointer"
        variants={{
          rest: {},
          hover: {},
        }}
        onClick={handleNewSpark}
      >
        {colorScheme === "docs" ? <SparkSvg className="photon-navigation-icon photon-product-icon" aria-hidden="true" /> : theme === "dark" ? <SparkDarkSvg /> : <SparkSvg />}
        <motion.div
          className="photon-navigation-label text-sm font-semibold text-ink-control-border dark:text-ink-white"
          variants={{
            rest: {},
            hover: {},
          }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          inherit={false}
        >
          Spark
        </motion.div>
        <motion.div
          className="ml-2 text-ink-ink-deep dark:text-ink-white"
          variants={{
            rest: { opacity: 0, x: -5 },
            hover: {
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.3,
                ease: "easeOut",
              },
            },
          }}
          inherit={false}
        >
          <ArrowUp className="dark:fill-ink-white fill-ink-ink-deep w-[11px] h-4 rotate-90" />
        </motion.div>
      </motion.button>
      <AddButton onClick={handleAddChat}>New Spark</AddButton>
    </motion.div>
  );
};
